import React, {useState} from 'react';
import styled from 'styled-components'
import { StaticImage } from "gatsby-plugin-image" 
import {scrollTo} from './scrollTo'

const Arrow = () => (
  <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 0.999999L7 7L1 1" stroke="white" stroke-width="2"/>
  </svg>
)

const VerticalTabs = ({ children, datas=[] }) => {

  const [active, setActive] = useState(null);
  const childrens = React.Children.toArray(children) || [];

  return (
    <Wrapper>
      {datas && datas.map((item, index) => {console.log('item => ',item); return (
        <Line
          id={`tab${index}`}
          key={'tab'+index}
          className={`${active === index ? 'active' : ''}`} 
        >
          <Top
            className={`${active === index ? 'active' : ''}`} 
            onClick={(e) => {
              if(active !== index) {
                setActive(index);
                scrollTo({id: `tab${index}`});
              }else setActive(null)
            }}
            href={`#tab${index}`}
          >
            {/* <StaticImage 
              src={item?.img}
              alt="etat" 
              width={74}
            /> */}
            <img src={item?.img} width={74} />
            <span dangerouslySetInnerHTML={{ __html: item?.title }}  />

            <Arrow />
          </Top>
          {index === active ? (
            <Content>
              {childrens && childrens[index]}
            </Content>
          ) : null}
        </Line>
      )})}
    </Wrapper>
  );

};


const Wrapper = styled.div`
  /* margin-bottom: 40px; */
`

const Top = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  transition: all 0.3s;

  &.active {
    background: #CDB757;
    border-bottom: 1px solid rgba(255,255,255,0);

    span {
      color: #171717;
    }
    svg {
      transform: translateY(-50%) rotate(180deg);
      path {
        stroke: #171717;
      }
    }
  }

  span {
    color: #FFF;
    margin-left: 16px;
    font-weight: 700;
    font-size: 20px;
    line-height: 23px;
    transition: all 0.3s;
  }

  svg {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.3s;
  }
`
const Line = styled.div``

const Link = styled.div`

`

const Content = styled.div`
  padding: 40px 24px 20px 24px;
  border: 6px solid #CDB757;
`


export default VerticalTabs;